// // Wait for the DOM to be fully loaded before executing
// document.addEventListener("DOMContentLoaded", () => {
//   const ball = document.querySelector(".cursor");

//   // Track mouse movements
//   document.addEventListener("mousemove", (e) => {
//     const mouseX = e.clientX; // Mouse X position
//     const mouseY = e.clientY; // Mouse Y position

//     // Move the ball to the cursor position
//     ball.style.transform = `translate(${mouseX - ball.offsetWidth / 2}px, ${
//       mouseY - ball.offsetHeight / 2
//     }px)`;
//   });
// });
